import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useCentroCustoOutletContext } from 'pages/CentroCusto.context'
import { useParams } from 'react-router-dom'
import { FuncionariosAssociadosCentroCusto } from '../FuncionariosAssociados'

export default function AssociarCentroCusto() {
    const { id } = useParams()
    const { data } = useCentroCustoOutletContext()
    const centroCusto = data?.find(item => item.id === Number(id))

    if (!centroCusto) return null

    return (
        <Dialog.Root open={hasPermission(['read', 'Funcionários'])}>
            <Dialog.Title>
                Funcionários do centro de custo {centroCusto.nomeCentroCusto}
            </Dialog.Title>
            <Dialog.Content>
                <FuncionariosAssociadosCentroCusto
                    centroCustoId={centroCusto.id}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
